import React, { useEffect, useState } from 'react';
import HeaderCommun from './HeaderCommun';
import axios from 'axios';

const rawNavigation = [
  {
    name: 'Dashboard',
    href: '/Candidat/Dashboard',
    permissionKey: 'dashboard'
  },
  {
    name: 'Mes candidatures',
    href: '/candidat/candidatures',
    permissionKey: 'candidatures'
  }
];

const userNavigation = [
  { name: 'Mon compte', href: '/candidat/profile' },
  { name: 'Se déconnecter' }
];

const HeaderCandidat = () => {
  const [filteredNav, setFilteredNav] = useState([]);
  const [candidatName, setCandidatName] = useState(localStorage.getItem('userName') || 'Candidat');
  const [candidatAvatar, setCandidatAvatar] = useState(localStorage.getItem('candidatAvatar') || null);

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchPermissions = async () => {
      const userType = localStorage.getItem('userType');
      if (!userType) return;
      try {
        const res = await axios.get(`${API_BASE}/api/roles/${userType.toLowerCase()}/permissions`);
        const permissions = res.data || {};
        const navWithAccess = rawNavigation
          .map(item => permissions[item.permissionKey]?.Accès ? item : null)
          .filter(Boolean);
        setFilteredNav(navWithAccess);
      } catch {
        setFilteredNav([]);
      }
    };

    const handleStorageUpdate = () => {
      setCandidatName(localStorage.getItem("candidatName") || 'Candidat');
      setCandidatAvatar(localStorage.getItem("candidatAvatar") || null);
    };

    fetchPermissions();
    window.addEventListener("storage", handleStorageUpdate);
    return () => window.removeEventListener("storage", handleStorageUpdate);
  }, []);

  return (
    <HeaderCommun
      userName={candidatName}
      navigation={filteredNav}
      userNavigation={userNavigation}
      cagnotte={null} // pas utilisé pour candidat
      userAvatar={candidatAvatar ? `${API_BASE}${candidatAvatar}?t=${Date.now()}` : null}
      addButtonLabel={null}
      addButtonHref={null}
      userRole="candidat"
    />
  );
};

export default HeaderCandidat;
